import { useMemo } from 'react';
import { find } from 'lodash';
import { DetailsObjectType } from 'store/pages/loaders/loader-types';
import PLAYER_TYPES from 'constants/player-types';

type ParamsType = {
  playerType: string;
  queryParams: {
    objectId: number;
    episodeId: number;
  };
  object: DetailsObjectType;
  isObjectLoading?: boolean;
};

const useVideoTarget = ({ playerType, queryParams, object, isObjectLoading }: ParamsType) => {
  const videoTarget = useMemo(() => {
    if (isObjectLoading) return null;

    if (playerType === PLAYER_TYPES.SERIES) {
      const currentSeason = find(
        object?.series_seasons,
        (season) => !!find(season.episodes, { id: queryParams.episodeId }),
      );

      return find(currentSeason?.episodes, { id: queryParams.episodeId });
    } else {
      return object;
    }
  }, [isObjectLoading, object, playerType, queryParams]);

  return videoTarget;
};

export default useVideoTarget;
